module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planetOpen),
      expression: "planetOpen"
    }],
    staticClass: "box__Works"
  }, [_c('header'), _c('div', {
    staticClass: "container__bg"
  }, [_c('section', _vm._l((_vm.works), function(work) {
    return _c('div', {
      staticClass: "box__work"
    }, [_c('h3', [_c('a', {
      attrs: {
        "href": work.link,
        "target": "_new"
      }
    }, [_vm._v(_vm._s(work.name))])]), _c('h4', [_vm._v("- " + _vm._s(work.technologies))]), _c('p', [_vm._v(_vm._s(work.description))])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1422c5d2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/Works/Works.vue
// module id = 57
// module chunks = 0